module.exports = __webpack_public_path__ + "img/subjectchart.c267ded5.png";